"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAgreement = selectAgreement;
exports.selectIsAgreementNextLoading = selectIsAgreementNextLoading;
exports.viewDataSelector = viewDataSelector;
var _phoneAuth = require("../../../../types/phoneAuth");
var _requestStatus = require("../../../../types/requestStatus");
function selectIsAgreementNextLoading(state) {
  return state.phoneAuth.sendValidationCode.status === _requestStatus.ERequestStatus.Loading || state.phoneAuth.registerOrAuthByToken.status === _phoneAuth.ERegisterOrAuthByTokenStatus.Loading;
}
function selectAgreement(state) {
  return state.agreement;
}
function viewDataSelector(state) {
  return state.view.data;
}